import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePermissions } from "@/hooks/usePermissions";
import { titleKeyForPath } from "./document-title";

/**
 * Keeps `document.title` in sync with the active route (tab label next to the favicon).
 * Must render under `RouterProvider` + i18n.
 */
export function DocumentTitle() {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const permissions = usePermissions();
  const reviewLabelKey = permissions.can("action.scientificValidate")
    ? "nav.scientificReview"
    : "nav.review";

  useEffect(() => {
    const page = t(titleKeyForPath(pathname, reviewLabelKey));
    const app = t("app.name");
    document.title = pathname === "/" ? app : `${page} · ${app}`;
  }, [pathname, reviewLabelKey, t, i18n.language]);

  return null;
}
